import * as Api from '@ViewModels';

export function isCanvasOnlyAutomationTemplate(
	template?: Pick<Api.IAbstractAutomationTemplate, 'hasSubSegments'> | null
): boolean {
	return template?.hasSubSegments === true;
}

export function canUseLegacyAutomationEditor(
	template?: Pick<Api.IAbstractAutomationTemplate, 'hasSubSegments'> | null
): boolean {
	return !isCanvasOnlyAutomationTemplate(template);
}
